import { EnderecoWsCepService } from './endereco-ws-cep.service';
import { Component, OnInit } from '@angular/core';
import notify from 'devextreme/ui/notify';
import { Mascaras } from './../app.config';

@Component({
  selector: 'ntc-endereco-ws-cep',
  templateUrl: './endereco-ws-cep.component.html',
  styleUrls: ['./endereco-ws-cep.component.css']
})
export class EnderecoWsCepComponent implements OnInit {

  inputCep = '';
  inputLogradouro = '';
  inputLocalidade = '';
  inputUf = '';

  enderecoCep = {
      Logradouro: null,
      Numero: null,
      Complemento: null,
      Bairro: null,
      Localidade: null,
      Uf: null,
      Cep: null,
      Ibge: null
  };

  listaCeps = [];

  MascaraCEP = Mascaras.Cep;

  constructor(private enderecoWsCepService: EnderecoWsCepService) {
  }

  ngOnInit() {
  }

  carregaDadosCep() {
    // converte em string
    const cepStr = this.inputCep.toString();

    // deixa variavel somente com numeros
    const cep = cepStr.replace(/\D/g, '');

    // consulta o WebService em busca dos dados do cep
    this.enderecoWsCepService.getEnderecoWsCep(cep)
    .subscribe(retornoCep => {
      //console.log(retornoCep);
      if (retornoCep.hasOwnProperty('cep')) {
        this.enderecoCep.Logradouro = retornoCep.logradouro;
        this.enderecoCep.Bairro = retornoCep.bairro;
        this.enderecoCep.Localidade = retornoCep.localidade;
        this.enderecoCep.Uf = retornoCep.uf;
        this.enderecoCep.Cep = retornoCep.cep;
        this.enderecoCep.Ibge = retornoCep.ibge;
        notify('Cep encontrado!', 'success', 2000);
      } else {
        notify('Cep não encontrado!', 'warning', 2000);
      }
    },
    error => {
      notify('Erro ao consumir Webservice Cep!', 'error', 2000);
    });

  }

  carregaDadosLogradouro() {
    // consulta o WebService em busca dos dados do cep pelo logradouro
    this.enderecoWsCepService.getEnderecoWsCepLogradouro(this.inputLogradouro, this.inputLocalidade, this.inputUf)
    .subscribe(listaCeps => {
      //console.log(listaCeps);
      if (listaCeps.length > 0) {
        this.listaCeps = listaCeps;
         notify('Logradouro encontrado!', 'success', 2000);
      } else {
        this.listaCeps = [];
        notify('Logradouro não encontrado!', 'warning', 2000);
      }
    },
    error => {
      notify('Erro ao consumir Webservice Cep!', 'error', 2000);
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/endereco-ws-cep/endereco-ws-cep.component.ts